/**
 * @file block-limits.ts
 * @description Сколько блоков помещается на страницу конструктора (SB64;
 * phase19.16 Р2а): у обычной страницы и места — `SITE_LIMITS.sectionsPerPage`,
 * у шаблона страницы товара — свой `productTemplateSections`. Одно правило
 * для списка блоков, «Добавить блок», «Дублировать» и «+ блок сюда» на канве.
 */

import { SITE_LIMITS } from "@chaiberi/shared";

import type { SitePageKind } from "../api-site-pages";
import { TEMPLATE_BLOCKS_FULL_TEXT } from "./product-element-meta";

/** Почему на обычную страницу больше нельзя добавить блок. */
export const BLOCKS_FULL_TEXT = `На странице ${SITE_LIMITS.sectionsPerPage} блоков — больше не поместится. Удалите лишний или перенесите часть на другую страницу.`;

/** Страница или её блоки: вид страницы (может быть ещё не загружен) и сколько блоков. */
interface BlocksOnPage {
  kind?: SitePageKind | null;
  blocks: ReadonlyArray<unknown>;
}

/** Предел блоков для вида страницы. */
export function blockLimitFor(kind: SitePageKind | null | undefined): number {
  return kind === "TEMPLATE" ? SITE_LIMITS.productTemplateSections : SITE_LIMITS.sectionsPerPage;
}

/** Почему на страницу больше нельзя добавить блок; `null` — можно (или страницы нет). */
export function blocksFullText(page: BlocksOnPage | null | undefined): string | null {
  if (!page || page.blocks.length < blockLimitFor(page.kind)) return null;
  return page.kind === "TEMPLATE" ? TEMPLATE_BLOCKS_FULL_TEXT : BLOCKS_FULL_TEXT;
}
